<template>
  <nuxt-layout name="default">
    <div class="error-page">
      <div class="max-w-screen-2xl mx-auto pt-16 px-4">
        <h1 v-if="error.statusCode === 404" class="uppercase">
          {{ t('general/error/alternative_title') }}
        </h1>
        <h1 v-else class="uppercase">
          {{ t('general/non_special_texts/error') }}
        </h1>
        <p v-if="error.statusCode === 500">
          {{ error.message || t('general/error/text') }}
        </p>
        <p v-else>
          {{ t('general/error/alternative_subtitle') }}
        </p>
        <p v-if="sentryEvent">
          {{
            t('general/error/sentry_event', {
              id: sentryEvent,
            })
          }}
        </p>
        
        <common-button
          size="custom"
          class="inline-flex items-center gap-2 px-5 py-2.5"
          @click="handleError"
        >
          <fa-icon :icon="faArrowLeft" class="size-4" aria-hidden="true" />
          {{ t('frontend/back') }}
        </common-button>
      </div>
    </div>
  </nuxt-layout>
</template>

<script setup lang="ts">
import type { NuxtError } from '#app';
import { lastEventId } from '@sentry/nuxt';
import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';

defineProps<{
  error: NuxtError;
}>();

const sentryEvent = computed(() => lastEventId() || null);

const { t, locale } = useI18n();

const handleError = () => {
  clearError({ redirect: `/${locale.value}` });
};
</script>

<style scoped>
.error-page {
  background: url(/sc/images/svgs/spaceship.svg) no-repeat;
  background-position: 30% 80%;
  background-size: 350%;
  min-height: 110vh;
  width: 100%;
  max-width: unset;

  @media (min-width: 768px) {
    background-size: 200%;
    background-position: 50% 100%;
  }

  @media (min-width: 1200px) {
    background-size: 110%;
    background-position: bottom;
  }
}
</style>
